import { createContext, ReactNode, useState } from "react";
import Modal from "../../Components/Common/Modal";
import { IModalContext } from "../../Types/Modal/Modal.type";

export const ModalContext = createContext<IModalContext | undefined>(undefined);

interface IModalProvider {
    children: ReactNode;
}

export const ModalProvider: React.FC<IModalProvider> = ({children}) => {
    const [modalContent, setModalContent] = useState<ReactNode | null>(null);

    const openModal= (content: ReactNode) => 
        setModalContent(content);
    const closeModal = () => 
        setModalContent(null);

    return (
        <ModalContext.Provider value={{ modalContent, openModal, closeModal}}>
            {children}
            {modalContent && <Modal>{modalContent}</Modal>}
        </ModalContext.Provider>
    )
}